import { CoverLetter, Optional, Resume } from 'packages/types'
import { A4_FACTOR, US_LETTER_FACTOR } from 'builder/modules/constants'
import { isResumeDocument } from 'builder/utils/getDocumentType'
import { camelCase } from 'builder/utils/camelCase'

function templateHeightFactorSelector(currentDocument: Optional<Resume | CoverLetter>) {
  const formatFromSettings =
    isResumeDocument(currentDocument) &&
    currentDocument?.templateSettings?.[camelCase(currentDocument?.template)]?.format

  if (formatFromSettings) {
    return formatFromSettings === 'US_LETTER' ? US_LETTER_FACTOR : A4_FACTOR
  }

  const formatFromTemplateConfig =
    isResumeDocument(currentDocument) && currentDocument?.templateConfig?.settings?.format

  return formatFromTemplateConfig === 'US_LETTER' ? US_LETTER_FACTOR : A4_FACTOR
}

export default templateHeightFactorSelector
